import { APP_ENV } from 'config';

export const BASE_URL =
  APP_ENV === 'qa'
    ? 'https://quote-qa.ideal4finance.co.uk/'
    : 'https://quote.ideal4finance.co.uk/';
